


export function coverIMG(imglist) {
    // 看是否是有效的值
    if (!(imglist instanceof Array) || imglist.length == 0) {
        return "https://vmsres.dianzhenkeji.com/0/hnr/2021/1/26/1353874969687474176.png";
    }

    const img = imglist.find((e) => {
        return e.coverBool == true;
    });
    if (img) {
        return img.url;
    } else {
        return imglist[0].url;
    }
}